import { useShadow, useShadowStyle } from "../../util/wcUtil.ts"
import { sendEv } from '../../data/events.ts';
import { closePanel, onPanelButtons } from './modalPanel.ts';
import styleText from './shared-modal-styles.css?raw';

/**
 * Offers to reopen an unsaved session from a previous visit. Nothing opens this
 * panel at the moment: IDB-based recovery is disabled alongside autosave (see
 * ProjectMixin's connectedCallback). The two intents it sends are handled
 * there, so re-enabling the opener is all it takes to bring the flow back.
 */
export class AsModalRestoreSession extends HTMLElement {
  static readonly tag = 'as-modal-restore-session' as const;

  get html() {
    return /*html*/`
      <div class="panel-content">
        <as-text dict-key="apps.general.restore-session.title">Unsaved Session Found</as-text>
        <as-text dict-key="apps.general.restore-session.body">You have an unsaved session from a previous visit. Would you like to restore it or start fresh?</as-text>
        <div class="row option-buttons">
          <as-text-button name="discard-unsaved-session" dict-key="modals.restore-session.start-new">Start New</as-text-button>
          <as-text-button name="restore-unsaved-session" dict-key="modals.restore-session.restore">Restore</as-text-button>
        </div>
      </div>
    `;
  }

  connectedCallback() {
    useShadow(this, this.html)
    useShadowStyle(this, styleText, './shared-modal-styles.css')
    onPanelButtons(this, {
      'restore-unsaved-session': () => {
        closePanel(this);
        sendEv(this, 'as-intrn-restore-unsaved-session');
      },
      'discard-unsaved-session': () => {
        closePanel(this);
        sendEv(this, 'as-intrn-discard-unsaved-session');
      },
    });
  }
}

if (!customElements.get(AsModalRestoreSession.tag)) {
  customElements.define(AsModalRestoreSession.tag, AsModalRestoreSession);
} else {
  console.warn('as-modal-restore-session already defined');
}
